import { CircularProgress, usePersistenceObjectUpdate, Button, MedStepWrapper, useIsMounted, FileDropSingle } from '@fox/atoms';
import { FlexColumnSpacedLarge } from '@fox/layout';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useImportWizardContext } from './import-wizard';
import { ACCEPTED_FORMATS } from './parse-data';

export const ImportData = ({ guidelines }: { guidelines: JSX.Element }) => {
	const { state: data, dispatch, onDrop, mapRef, setMapping } = useImportWizardContext() ?? {};
	const isMounted = useIsMounted();
	const [loading, setLoading] = useState(false);

	// the first port of call for changing data in the importer is in the file drop component. Can't do anything in importer without a file.
	// The file drop changes the state which we can then compare in the persistence context to the original state *without* sending anything to the server.
	// And that wonderful saveImmediate function that updateData calls, tells us if we're dirty - which we are, and always will be, after file drop, until refresh.
	const { updateData } = usePersistenceObjectUpdate();

	async function onFileDrop(e) {
		const isValid = e?.length === 1;
		if (!isValid) return;
		setLoading(true);
		await updateData(data);

		await onDrop(e);

		if (isMounted.current) setLoading(false);
	}

	return (
		<MedStepWrapper>
			<FlexColumnSpacedLarge>
				{guidelines}
				<FileDropSingle
					accept={ACCEPTED_FORMATS}
					file={data.fileData}
					onDrop={onFileDrop}
					clear={() => {
						for (const mapping in mapRef) {
							setMapping(mapping, null);
						}
						dispatch({ type: 'CLEAR_FILE' });
					}}
				>
					{!loading ? 'Click here to upload an Excel file, or just drag and drop into this box.' : <CircularProgress />}
				</FileDropSingle>
			</FlexColumnSpacedLarge>
		</MedStepWrapper>
	);
};
export const ImportButtonLeft = () => {
	const history = useNavigate();
	return (
		<>
			<Button
				style={{ whiteSpace: 'nowrap' }}
				variant="primary"
				startIconName="ArrowBackIosNew"
				title="Back"
				onClick={() => history(-1)}
			>
				Cancel
			</Button>
		</>
	);
};
